<template>
  <v-row>
    <!--  Approved access  -->
    <approved-access />

    <!--  Pending access  -->
    <pending-access />

    <!-- Shared with me accounts   -->
    <shared-with-me />
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ApprovedAccess from 'Components/Profile/Access/Approved/Approved'
import PendingAccess from 'Components/Profile/Access/Pending/Pending'
import SharedWithMe from 'Components/Profile/Access/Shared/Shared'

export default {
  name: 'ProfileAccess',
  components: {
    ApprovedAccess,
    PendingAccess,
    SharedWithMe,
  },
  computed: {
    ...mapGetters(['accessApprovedList', 'accessPendingList', 'myAccessList', 'services']),
  },
  methods: {
    ...mapActions(['reportError', 'getAccessList', 'getAccountList']),
    async loadAccessList () {
      try {
        await this.getAccessList()
      } catch (e) {
        this.reportError(e)
      }
    },
    async loadLists () {
      this.listsLoaded = false
      try {
        await this.getAccountList()
      } catch (e) {
        this.reportError(e)
      }
      this.listsLoaded = true
    },
  }
}
</script>

<style>
  .access__title .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
  }
</style>
